var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2700 312",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1743.3,100.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.892C5.15,19.892 9.344,15.571 9.344,9.823C9.344,4.224 5.15,0.05 0,0.05C-5.148,0.05 -9.343,4.224 -9.343,9.823C-9.343,15.571 -5.148,19.892 0,19.892M0,-2.995C7.009,-2.995 12.68,2.506 12.68,9.823C12.68,17.288 7.009,22.887 0,22.887C-7.007,22.887 -12.68,17.288 -12.68,9.823C-12.68,2.506 -7.007,-2.995 0,-2.995",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1831.63,146.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.912L0,-12.191C0,-20.19 5.791,-21.2 8.61,-21.2C9.549,-21.2 10.145,-21.104 10.145,-21.104L10.145,-18.166C10.145,-18.166 9.65,-18.262 8.958,-18.262C7.026,-18.262 3.364,-17.588 3.364,-12.191L3.364,-11.035L9.749,-11.035L9.749,-8.288L3.364,-8.288L3.364,12.912L0,12.912Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1950.51,127.747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.157C0,10.157 2.76,12.917 6.852,12.917C8.627,12.917 10.157,12.128 10.157,10.65C10.157,6.904 -2.071,7.397 -2.071,-0.689C-2.071,-5.372 2.121,-8.084 7.543,-8.084C13.212,-8.084 15.974,-5.224 15.974,-5.224L13.655,-0.591C13.655,-0.591 11.34,-2.76 7.493,-2.76C5.865,-2.76 4.29,-2.069 4.29,-0.493C4.29,3.057 16.515,2.614 16.515,10.698C16.515,14.89 12.867,18.241 6.902,18.241C0.641,18.241 -2.86,14.545 -2.86,14.545L0,10.157Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2134.04,167.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.212C-0.1,-9.614 -2.219,-11.438 -4.981,-11.438C-8.184,-11.438 -10.402,-9.465 -10.995,-6.212L0,-6.212ZM-4.831,-16.269C2.415,-16.269 6.31,-10.993 6.31,-4.338C6.31,-3.598 6.162,-1.922 6.162,-1.922L-11.191,-1.922C-10.798,2.466 -7.397,4.733 -3.648,4.733C0.393,4.733 3.598,1.972 3.598,1.972L6.014,6.459C6.014,6.459 2.169,10.057 -4.091,10.057C-12.424,10.057 -17.602,4.043 -17.602,-3.105C-17.602,-10.846 -12.326,-16.269 -4.831,-16.269",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2229.68,112.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.563C3.303,16.563 5.671,13.015 5.671,9.958L5.671,9.367L4.584,9.367C1.381,9.367 -3.795,9.81 -3.795,13.31C-3.795,14.985 -2.562,16.563 0,16.563M4.783,5.077L5.621,5.077L5.621,4.732C5.621,1.429 3.55,0.294 0.79,0.294C-2.808,0.294 -6.114,2.71 -6.114,2.71L-8.479,-1.776C-8.479,-1.776 -4.584,-4.881 1.381,-4.881C7.986,-4.881 11.831,-1.233 11.831,5.127L11.831,20.853L6.064,20.853L6.064,18.782C6.064,17.796 6.164,17.008 6.164,17.008L6.064,17.008C6.114,17.008 4.141,21.444 -1.576,21.444C-6.064,21.444 -10.105,18.634 -10.105,13.606C-10.105,5.62 0.69,5.077 4.783,5.077",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2312.29,155.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-7.789L0.148,-12.768L0.148,-20.015L6.262,-20.015L6.262,-12.768L11.979,-12.768L11.979,-7.789L6.262,-7.789L6.262,1.971C6.262,6.112 9.513,6.704 11.239,6.704C11.931,6.704 12.374,6.606 12.374,6.606L12.374,12.078C12.374,12.078 11.636,12.226 10.452,12.226C6.952,12.226 0,11.192 0,2.761L0,-7.789Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2396.33,155.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-7.789L0.148,-12.768L0.148,-20.015L6.26,-20.015L6.26,-12.768L11.981,-12.768L11.981,-7.789L6.26,-7.789L6.26,1.971C6.26,6.112 9.515,6.704 11.241,6.704C11.931,6.704 12.374,6.606 12.374,6.606L12.374,12.078C12.374,12.078 11.634,12.226 10.452,12.226C6.952,12.226 0,11.192 0,2.761L0,-7.789Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2480.6,215.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-35.25L6.212,-35.25L6.212,-9.023C6.212,-6.261 7.148,-5.571 8.774,-5.571C9.267,-5.571 9.712,-5.621 9.712,-5.621L9.712,-0.149C9.712,-0.149 8.774,0 7.74,0C4.29,0 0,-0.888 0,-8.085L0,-35.25Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,2628.77,167.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.212C-0.098,-9.614 -2.219,-11.438 -4.979,-11.438C-8.183,-11.438 -10.402,-9.465 -10.995,-6.212L0,-6.212ZM-4.831,-16.269C2.415,-16.269 6.31,-10.993 6.31,-4.338C6.31,-3.598 6.164,-1.922 6.164,-1.922L-11.191,-1.922C-10.796,2.466 -7.395,4.733 -3.648,4.733C0.395,4.733 3.598,1.972 3.598,1.972L6.014,6.459C6.014,6.459 2.169,10.057 -4.091,10.057C-12.424,10.057 -17.6,4.043 -17.6,-3.105C-17.6,-10.846 -12.324,-16.269 -4.831,-16.269",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,544.438,165.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.212C-0.098,-9.614 -2.217,-11.438 -4.979,-11.438C-8.184,-11.438 -10.402,-9.465 -10.993,-6.212L0,-6.212ZM-4.831,-16.269C2.417,-16.269 6.31,-10.993 6.31,-4.338C6.31,-3.598 6.162,-1.922 6.162,-1.922L-11.189,-1.922C-10.796,2.466 -7.395,4.733 -3.648,4.733C0.395,4.733 3.6,1.972 3.6,1.972L6.016,6.459C6.016,6.459 2.171,10.057 -4.091,10.057C-12.422,10.057 -17.6,4.043 -17.6,-3.105C-17.6,-10.846 -12.326,-16.269 -4.831,-16.269",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,594.332,119.769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.876C0,22.876 1.381,23.91 2.812,23.91C4.536,23.91 6.214,22.876 7.15,20.657L8.086,18.438L-2.512,-6.31L4.536,-6.31L9.812,8.185C10.305,9.516 10.748,11.587 10.748,11.587L10.846,11.587C10.846,11.587 11.241,9.614 11.684,8.283L16.615,-6.31L23.467,-6.31L12.228,22.629C10.452,27.214 6.954,29.186 3.155,29.186C0.15,29.186 -2.069,27.559 -2.069,27.559L0,22.876Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,804.73,165.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.212C-0.096,-9.614 -2.217,-11.438 -4.977,-11.438C-8.183,-11.438 -10.402,-9.465 -10.991,-6.212L0,-6.212ZM-4.831,-16.269C2.415,-16.269 6.31,-10.993 6.31,-4.338C6.31,-3.598 6.164,-1.922 6.164,-1.922L-11.189,-1.922C-10.794,2.466 -7.393,4.733 -3.648,4.733C0.397,4.733 3.6,1.972 3.6,1.972L6.016,6.459C6.016,6.459 2.171,10.057 -4.091,10.057C-12.422,10.057 -17.598,4.043 -17.598,-3.105C-17.598,-10.846 -12.324,-16.269 -4.831,-16.269",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,978.107,215.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-26.325C6.557,-26.325 9.664,-22.579 9.664,-22.579L6.904,-18.289C6.904,-18.289 4.29,-21.001 0.347,-21.001C-4.288,-21.001 -7.296,-17.501 -7.296,-13.211C-7.296,-8.972 -4.238,-5.324 0.543,-5.324C4.783,-5.324 7.938,-8.529 7.938,-8.529L10.355,-4.091C10.355,-4.091 6.755,0 0,0C-8.331,0 -13.655,-5.867 -13.655,-13.161C-13.655,-20.309 -8.331,-26.325 0,-26.325",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1050.28,213.461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-35.25L6.212,-35.25L6.212,-9.023C6.212,-6.261 7.15,-5.571 8.776,-5.571C9.269,-5.571 9.712,-5.621 9.712,-5.621L9.712,-0.149C9.712,-0.149 8.776,0 7.739,0C4.29,0 0,-0.888 0,-8.085L0,-35.25Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,-336.986,-181.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.859,
    y: 55.096,
    width: 6.26,
    height: 25.143,
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1185.4,209.347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-24.552L6.016,-24.552L6.016,-21.643C6.016,-20.707 5.915,-19.918 5.915,-19.918L6.016,-19.918C7.098,-22.038 9.86,-25.143 14.938,-25.143C20.508,-25.143 23.663,-22.235 23.663,-15.58L23.663,0.591L17.453,0.591L17.453,-14.297C17.453,-17.354 16.664,-19.424 13.458,-19.424C10.107,-19.424 7.641,-17.306 6.705,-14.297C6.358,-13.263 6.262,-12.128 6.262,-10.945L6.262,0.591L0,0.591L0,-24.552Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,-336.986,-181.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.252,
    y: 55.096,
    width: 6.26,
    height: 25.143,
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1456.58,215.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-26.325C6.557,-26.325 9.662,-22.579 9.662,-22.579L6.9,-18.289C6.9,-18.289 4.288,-21.001 0.343,-21.001C-4.29,-21.001 -7.296,-17.501 -7.296,-13.211C-7.296,-8.972 -4.241,-5.324 0.541,-5.324C4.781,-5.324 7.936,-8.529 7.936,-8.529L10.351,-4.091C10.351,-4.091 6.753,0 0,0C-8.333,0 -13.657,-5.867 -13.657,-13.161C-13.657,-20.309 -8.333,-26.325 0,-26.325",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.91052,0,0,4.91052,1534.08,125.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.157C0,10.157 2.76,12.917 6.852,12.917C8.627,12.917 10.157,12.128 10.157,10.65C10.157,6.904 -2.071,7.397 -2.071,-0.689C-2.071,-5.372 2.121,-8.084 7.543,-8.084C13.212,-8.084 15.974,-5.224 15.974,-5.224L13.655,-0.591C13.655,-0.591 11.34,-2.76 7.493,-2.76C5.865,-2.76 4.29,-2.069 4.29,-0.493C4.29,3.057 16.515,2.614 16.515,10.698C16.515,14.89 12.867,18.241 6.902,18.241C0.641,18.241 -2.86,14.545 -2.86,14.545L0,10.157Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-4.91052,-4.91052,0,1135.41,33.8215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.665,-3.665C-5.688,-3.665 -7.329,-2.023 -7.329,-0C-7.329,2.023 -5.688,3.665 -3.665,3.665C-1.64,3.665 -0,2.023 -0,-0C-0,-2.023 -1.64,-3.665 -3.665,-3.665",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-4.91052,-4.91052,0,1348.92,33.8215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.665,-3.665C-5.688,-3.665 -7.329,-2.023 -7.329,-0C-7.329,2.023 -5.688,3.665 -3.665,3.665C-1.64,3.665 -0,2.023 -0,-0C-0,-2.023 -1.64,-3.665 -3.665,-3.665",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.757192,0,0,0.757192,29.0651,38.1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.723,174.463C341.964,229.842 293.557,271.978 235.386,271.978C170.186,271.978 117.252,219.045 117.252,153.847C117.252,88.648 170.186,35.715 235.386,35.715C293.557,35.715 341.964,77.851 351.724,133.237L351.69,133.237L351.685,133.209L284.531,133.209C276.524,113.934 257.517,100.381 235.346,100.381C205.942,100.381 182.105,124.214 182.105,153.618C182.105,183.023 205.942,206.856 235.346,206.856C257.34,206.856 276.221,193.517 284.339,174.484L351.685,174.484L351.689,174.463L351.723,174.463Z",
    style: {
      fill: "url(#_Radial1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.15497,0,0,3.15497,205.794,38.1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,74.709C-37.184,74.709 -54.71,42.318 -55.392,40.841L-56.016,39.492L-55.37,38.154C-54.667,36.701 -36.671,0.298 1.25,0.001C1.408,0 1.567,0 1.724,0C39.463,0 54.398,35.347 54.544,35.706L55.702,38.982L2.753,38.982L2.956,34.835L44.978,34.458C40.037,25.728 28.606,4.939 -0.757,4.299C-0.902,4.296 -1.043,4.3 -1.189,4.301C-31.1,4.535 -42.81,24.11 -47.491,34.323C-45.363,42.195 -31.935,69.936 3.184,70.836C3.202,70.837 3.218,70.836 3.236,70.836C24.233,70.815 40.065,59.405 48.112,49.788L49.286,49.724C40.38,60.367 23.484,74.685 0.061,74.709L0,74.709Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-3.15497,-3.15497,0,207.267,124.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.569,-9.569C-14.854,-9.569 -19.138,-5.285 -19.138,0C-19.138,5.284 -14.854,9.569 -9.569,9.569C-4.284,9.569 0,5.284 0,0C0,-5.285 -4.284,-9.569 -9.569,-9.569",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,122.667,-122.667,0,235.032,150.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(57,161,214)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(143,189,225)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(29,149,199)",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcsLogo);
export default __webpack_public_path__ + "static/media/ecs_logo.f1cb54de2026453b4c3ea78826e01e6e.svg";
export { ForwardRef as ReactComponent };